import axios from 'axios';
import { nanoid } from 'nanoid'

export const config = {
	// baseURL: 'https://dtgs9zyofk.execute-api.us-east-1.amazonaws.com',
	// baseURL: 'https://24jczvhi6c.execute-api.us-east-1.amazonaws.com/v1',
	// baseURL: 'https://r0p0qhg1n0.execute-api.us-east-1.amazonaws.com/UAT',
	baseURL: 'https://s080lexhab.execute-api.us-east-1.amazonaws.com/v1/',
	apiVersion: '1.0'
};

export const axiosClient = axios.create({
	baseURL: config.baseURL,
	timeout: 10000,
});


axiosClient.interceptors.request.use(
	async function (config) {

		var accessToken = localStorage.getItem('token');
		if (accessToken !== null) {
			// config.headers.Authorization = `Bearer ${accessToken}`;
			config.headers.Authorization = `${accessToken}`;
		}
		var userinfo = localStorage.getItem('userinfo')
        config.headers.correlationid = `${nanoid()}`;
        if (userinfo) {
            var u_info = JSON.parse(userinfo);
            config.headers.storeid = `${u_info.roleinfo.profitcenterid}`;
            //config.headers.salesrepid = `${u_info.roleinfo.loginname}`;
			config.headers.salesrepname = `${u_info.roleinfo.loginname}`;
			config.headers.salesrepid = `${u_info.roleinfo.userloginid}`;
        }
		return config;
	},
	function (err) {
		return Promise.reject(err);
	}
);

axiosClient.defaults.timeout = 30000;
